/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createDashboardMessageFromDiscriminatorValue, type DashboardMessage } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Dashboard/GetMessages
 */
export interface GetMessagesRequestBuilder extends BaseRequestBuilder<GetMessagesRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<DashboardMessage[]>}
     */
     get(requestConfiguration?: RequestConfiguration<GetMessagesRequestBuilderGetQueryParameters> | undefined) : Promise<DashboardMessage[] | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<GetMessagesRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
export interface GetMessagesRequestBuilderGetQueryParameters {
    dashboardBookingId?: number;
}
/**
 * Uri template for the request builder.
 */
export const GetMessagesRequestBuilderUriTemplate = "{+baseurl}/Dashboard/GetMessages?dashboardBookingId={dashboardBookingId}";
/**
 * Metadata for all the requests in the request builder.
 */
export const GetMessagesRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: GetMessagesRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createDashboardMessageFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
